import {required,numeric} from "vuelidate/lib/validators";  
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric"; 
const StrOdenekTalep = {
  mixins: [Api, Sabit],
    data() {
      return { 
        StrOdenekTalepData:{
            Deleted: false,
            Birimid:null,
            Yil: 0,
            Ay: 0,
            Hesapkodid:null,
            Onay: false,
            Serbestodenek: 0,
            Blokeodenek: 0,
            Harcananodenek: 0,
            Talepedilenodenek: 0,
            Karsilananodenek: 0, 
            Aciklama: "",
            Onaypersonelid: null,
            Onayaciklama: "",
            Fileurl: ""
          },
        FormDataType:{ 

          Birimid:{FieldName:"Birimid",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Birimid'),ComboDataArray:[]}, 
          Yil:{FieldName:"Yil",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Yil'),ComboDataArray:[]},
          Ay:{FieldName:"Ay",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Ay'),FieldType:"number"},
          Hesapkodid:{FieldName:"Hesapkodid",Field:"combobox",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Hesapkodid'),ComboDataArray:[]}, 
          Onay:{FieldName:"Onay",Field:"checkbox",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Onay')},  
          Serbestodenek: {FieldName: "Serbestodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Serbestodenek"), FieldType: "number",},
          Blokeodenek: {FieldName: "Blokeodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Blokeodenek"), FieldType: "number",},
          Harcananodenek: {FieldName: "Serbestodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Harcananodenek"), FieldType: "number",},
          Talepedilenodenek: {FieldName: "Talepedilenodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Talepedilenodenek"), FieldType: "number",},
          Karsilananodenek: {FieldName: "Karsilananodenek",Field: "input",FieldTitle: this.$t("StrOdenekTalep.AddEdit.Karsilananodenek"), FieldType: "number",},
          Aciklama:{FieldName:"Aciklama",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Aciklama'),FieldType:"text"},
          Onayaciklama:{FieldName:"Onayaciklama",Field:"input",FieldTitle: this.$t('StrOdenekTalep.AddEdit.Onayaciklama'),FieldType:"text"},
          Onaypersonelid:{FieldName:"Onaypersonelid",Field:"input",FieldTitle:this.$t('StrOdenekTalep.AddEdit.Onaypersonelid')}, 
          Fileurl:{FieldName:"Fileurl",Field:"input",FieldTitle:"Dosya",FieldType:"text"},
          
        },

        Yillar:[
          {"id":"2023","value":"2023"},
          {"id":"2024","value":"2024"},
          {"id":"2025","value":"2025"},
          {"id":"2026","value":"2026"},
          {"id":"2027","value":"2027"},
          {"id":"2028","value":"2028"},
          {"id":"2029","value":"2029"},
          {"id":"2030","value":"2030"},

        ],
        Aylar:[
          {"id":"1","value":"Ocak"},
          {"id":"2","value":"Şubat"},
          {"id":"3","value":"Mart"},
          {"id":"4","value":"Nisan"},
          {"id":"5","value":"Mayıs"},
          {"id":"6","value":"Haziran"},
          {"id":"7","value":"Temmuz"},
          {"id":"8","value":"Ağustos"},
          {"id":"9","value":"Eylül"},
          {"id":"10","value":"Ekim"},
          {"id":"11","value":"Kasım"},
          {"id":"12","value":"Aralık"},

        ],
 
      }
    },
    validations:{ 
        FormData: {
          Birimid:{required}, 
          Yil:{required,numeric},
          Ay:{required,numeric},
          Hesapkodid:{required}, 
          Onay:{},  
          Serbestodenek: {required},
          Blokeodenek: {required},
          Harcananodenek: {required},
          Talepedilenodenek: {required},
          Karsilananodenek: {required},
          Aciklama:{},
          Onayaciklama: {},
          Onaypersonelid:{},
          Fileurl: {}
        } 
    },


    created(){ 
      let Page= {
        PageNumber: "1",
        PageSize: "9999"
      }
   
      let Filter = "&Basamak=4";

      this.ActionsFilterGet({Service:"StrHesapKodlari",Page:Page, Filter:Filter}).then(res => {  
        for(var i=0; i<res.Data.length; i++)
          {
            this.FormDataType.Hesapkodid.ComboDataArray.push ({id:res.Data[i].Id,label:res.Data[i].Kod + " " + res.Data[i].Aciklama})
          }    
      }); 
  
      var currentDate = new Date(); 
      this.FormDataType.Yil.ComboDataArray=[];
      for (var n=0 ; n<this.Yillar.length; n++){
 var Year =  currentDate.getFullYear()
        if(Year == this.Yillar[n].value){
          this.FormDataType.Yil.ComboDataArray.push ({Id:this.Yillar[n].id,Value:this.Yillar[n].value})
        }


      }

      this.FormDataType.Ay.ComboDataArray=[];
      for (var i=0 ; i<this.Aylar.length; i++){
        var nextMonthNumber = currentDate.getMonth() + 2;
      if (nextMonthNumber > 12) {
       nextMonthNumber = 1;
      }
      if(currentDate.getDate() <= 7){
        if(nextMonthNumber != 1){
        if((nextMonthNumber - 1) == this.Aylar[i].id){ 
          this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
        }
      }else{
        if((12) == this.Aylar[i].id){ 
          this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
        }
      }
      }
      if(currentDate.getDate() == 8){
        if(currentDate.getDay() - 1 == 7){
          if(nextMonthNumber != 1){
          if((nextMonthNumber - 1) == this.Aylar[i].id){ 
            this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
          }
        }else{
          if((12) == this.Aylar[i].id){ 
            this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
          }
          
        }
        }else{
          if(nextMonthNumber == this.Aylar[i].id){ 
            this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
          }
        }
      }
      if(currentDate.getDate() == 9){
        if(currentDate.getDay() - 2 == 7){
          if(nextMonthNumber != 1){
          if((nextMonthNumber - 1) == this.Aylar[i].id){ 
            this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
          }
                      
        }else{
          if((12) == this.Aylar[i].id){ 
            this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
          }
        }
        }else{
          if(nextMonthNumber == this.Aylar[i].id){ 
            this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
          }
        }
      }
      if(currentDate.getDate() > 9){
        if(nextMonthNumber == this.Aylar[i].id){ 
          this.FormDataType.Ay.ComboDataArray.push ({Id:this.Aylar[i].id,Value:this.Aylar[i].value})
        }
      }


      }

      
    }



}
export default StrOdenekTalep;